import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-manual',
  templateUrl: './help-manual.component.html',
  styleUrls: ['./help-manual.component.scss']
})
export class HelpManualComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
